import Content from './Content';
import styles from './styles.css';

export {
    Content,
    styles
};